import React from 'react';

export const PencilIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        id="Vector"
        d="M4.72567 14.3497L1 14.8828L1.53308 11.1571L11.1128 1.57741C11.3208 1.36064 11.57 1.18755 11.8458 1.0683C12.1215 0.949049 12.4183 0.886029 12.7187 0.882932C13.0192 0.879836 13.3172 0.936724 13.5953 1.05027C13.8735 1.16381 14.1262 1.33172 14.3387 1.54416C14.5511 1.7566 14.719 2.00931 14.8325 2.28746C14.9461 2.56562 15.003 2.86364 14.9999 3.16407C14.9968 3.46449 14.9338 3.76128 14.8145 4.03704C14.6953 4.3128 14.5222 4.56198 14.3054 4.77L4.72567 14.3497Z"
        stroke="#01619B"
      />
    </g>
  </svg>
);
